/**
 * Forwards UTM parameters from the landing-page URL to the checkout URL.
 *
 * - Reads every `utm_*` parameter from the current page URL.
 * - Remembers them for the session, so they survive in-page navigation.
 * - Keeps any query parameters the checkout URL already has, and never
 *   duplicates or overwrites a UTM that is already present on it.
 */
const STORAGE_KEY = 'wpp_utm_params'

function readPageUtms(): Array<[string, string]> {
  if (typeof window === 'undefined') return []

  const fromUrl: Array<[string, string]> = []
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (key.toLowerCase().startsWith('utm_') && value) fromUrl.push([key, value])
  })

  try {
    if (fromUrl.length > 0) {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl))
      return fromUrl
    }
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    return stored ? (JSON.parse(stored) as Array<[string, string]>) : []
  } catch {
    // Storage can be unavailable (private mode, in-app browsers) — URL still wins.
    return fromUrl
  }
}

export function withUtmParams(checkoutUrl: string): string {
  const utms = readPageUtms()
  if (utms.length === 0) return checkoutUrl

  try {
    const url = new URL(checkoutUrl)
    utms.forEach(([key, value]) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value)
    })
    return url.toString()
  } catch {
    return checkoutUrl
  }
}
